<template>
  <div id="wordpress" style="margin-left:10%;padding-top:5rem">
    <img src="@/assets/img/integration/WordPress_logo.png" style="max-width: 45%; margin:auto; display:block" />
    <h2 class="mt-5 documentation-header">How to Setup a Cense AI Chatbot for Wordpress</h2>
    <div style="margin-top:5%">
      <h6>
        1. Login to WordPress admin and navigate to the Plugins menu. It’s on the left side of the 
        <br> WordPress dashboard. Then Select Add New
      </h6>
      <br />
      <img src="@/assets/img/integration/wordpress1.png" />
    </div>
    <div style="margin-top:5%">
      <h6>2. On the Add Plugins page, search for “Cense AI Chatbot” and install it.</h6>
      <br />
      <img src="@/assets/img/integration/Wordpress2.png" />
    </div>
    <div style="margin-top:5%">
      <h6>3. Activate the plugin by clicking on the "Activate" button.</h6>
      <br />
      <img src="@/assets/img/integration/Wordpress3.png" />
    </div>
    <div style="margin-top:5%">
      <h6>
        4. Now navigate to the Settings menu. It’s on the left side of the WordPress dashboard.
        <br>Then Select Cense AI Chatbot plugin
      </h6>
      <br />
      <img src="@/assets/img/integration/Wordpress4.png" />
    </div>
    <div style="margin-top:5%">
      <h6>
        5. Enter your license key here. Copy the License key from 
        <a
          href="https://portal.cense.ai/bot/miscellaneous-settings"
        >Click here</a>
      </h6>
      <br />
      <img src="@/assets/img/integration/Wordpress5.png" />
    </div>
    <div style="margin-top:5%">
      <h6>6. Save your changes and You’re done. The Widget will now appear on all pages of your
        <br> WordPress site!</h6>
    </div>
  </div>
</template>

<script>
export default {
  name: "wordpress"
};
</script>


<style scoped>
h6 {
  font: normal normal normal 1rem/2.5rem Poppins;
}
</style>